import { render, staticRenderFns } from "./CustomerProjectDetails.vue?vue&type=template&id=fbd27f04&"
import script from "./CustomerProjectDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerProjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QCardSection,QInput,QField,QSeparator,QCardActions,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QCardSection,QInput,QField,QSeparator,QCardActions,QTable})
